import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useEnterpriseBrief(id) {
  const [brief, setBrief] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.enterprise_briefs.show(id))
      .then((response) => {
        setBrief(response.data.data);
      });
  }, []);

  return brief;
}
